import { uprightJpegBytes } from './imageOrient';

// Shared helpers for contractor document uploads (My Docs / upload-request banner).
// Normalise a picked file (PDF or photo) or a CameraCapture data URL into the
// { base64, contentType, filename } shape driver-docs-sb `uploadMyDoc` expects.
//
// Cap the ENCODED payload: base64 inflates bytes ~33% and Netlify's function body
// limit (6 MB) applies to the JSON we post, not the raw file — so a 5 MB photo can
// arrive as a 6.9 MB body that never lands. Mirrors MyDmsPortalTab's MAX_B64 guard.
const MAX_B64 = 5_000_000;

function abToB64(buf) {
  let bin = ''; const bytes = new Uint8Array(buf); const chunk = 0x8000;
  for (let i = 0; i < bytes.length; i += chunk) bin += String.fromCharCode.apply(null, bytes.subarray(i, i + chunk));
  return btoa(bin);
}

// A picked file (from an <input type="file">). PDFs pass through; images are
// re-oriented and downscaled to a baseline JPEG (fixes iPhone EXIF rotation).
export async function fileToUpload(file) {
  const isPdf = file.type === 'application/pdf' || /\.pdf$/i.test(file.name || '');
  if (isPdf) {
    const base64 = abToB64(await file.arrayBuffer());
    if (base64.length > MAX_B64) throw new Error('That file is too big — please keep it under about 5 MB.');
    return { base64, contentType: 'application/pdf', filename: file.name || 'document.pdf' };
  }
  let buf = await uprightJpegBytes(file, 2000, 0.82);
  let contentType = 'image/jpeg';
  if (!buf) { buf = await file.arrayBuffer(); contentType = file.type || 'image/jpeg'; }
  const base64 = abToB64(buf);
  if (base64.length > MAX_B64) throw new Error('That photo is too big — please retake it or use a smaller image.');
  const stem = (file.name || 'photo').replace(/\.[^.]+$/, '');
  return { base64, contentType, filename: `${stem}.jpg` };
}

// A CameraCapture data URL (image/jpeg, already downscaled by the component).
export function dataUrlToUpload(dataUrl, filename = 'photo.jpg') {
  const m = /^data:([^;]+);base64,(.*)$/.exec((dataUrl || '').toString());
  if (!m) throw new Error('Could not read that photo. Please retake it.');
  if (m[2].length > MAX_B64) throw new Error('That photo is too big — please retake it.');
  return { base64: m[2], contentType: m[1], filename };
}
